import logo from "../assets/logo.png";

export const NotFound = () => {
  return (
    <div className="bg-background flex min-h-screen items-center justify-center p-6">
      <div className="w-full max-w-2xl space-y-8 text-center">
        <div className="flex justify-center">
          <img src={logo} className="h-40 dark:brightness-150 dark:saturate-70" alt="Early Sun" />
        </div>

        <div className="space-y-2">
          <h1 className="text-primary text-8xl font-bold md:text-9xl">404</h1>
          <p className="text-2xl">Page not found</p>
          <p className="text-muted-foreground text-sm">Contact support if this is a mistake</p>
        </div>
      </div>
    </div>
  );
};
